import { colors, fonts } from "../../../../Styles";

export const consumptionsGraphsStyle = (() => {
  const _feedCurveWidth = 600;
  const _chartWidth = 550;
  const _chartHeight = 300;
  const _fontSize = { ...fonts.fontSize4 };
  const _primaryColor = colors.greyPrimary;

  return {
    feedCurveWidth: _feedCurveWidth,
    chartWidth: _chartWidth,
    chartHeight: _chartHeight,
    fontSize: _fontSize,
    primaryColor: _primaryColor,
  };
})();